"use client";

import { useEffect } from "react";
import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import posthog from "posthog-js";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    posthog.capture("$exception", {
      $exception_message: error.message,
      $exception_type: error.name,
      $exception_source: "error-boundary",
      digest: error.digest,
    });
  }, [error]);

  return (
    <main className="flex-1 flex items-center justify-center px-[var(--space-4)]">
      <div className="text-center space-y-[var(--space-4)] max-w-md">
        <div className="mx-auto flex size-12 items-center justify-center rounded-[var(--radius-full)] bg-[var(--color-error-subtle)]">
          <AlertTriangle className="size-6 text-[var(--color-error)]" aria-hidden="true" />
        </div>
        <h1 className="font-heading text-[length:var(--font-size-2xl)] tracking-[var(--letter-spacing-tight)] text-[var(--color-text-primary)]">
          Something went wrong
        </h1>
        <p className="text-[length:var(--font-size-sm)] text-[var(--color-text-muted)]">
          {error.message || "An unexpected error occurred. Please try again."}
        </p>
        <div className="flex gap-[var(--space-3)] justify-center">
          <Button onClick={reset}>Try again</Button>
          <Button variant="secondary">
            <a href="/">Go home</a>
          </Button>
        </div>
      </div>
    </main>
  );
}
